import { render, staticRenderFns } from "./FoodCombos.vue?vue&type=template&id=e3f40180&"
import script from "./FoodCombos.vue?vue&type=script&lang=js&"
export * from "./FoodCombos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports